import React from "react";
import useSEO from "../lib/useSEO";

export default function Privacy() {
    useSEO({ title: "Privacy Policy", description: "How Rotimi Jacobs & Co collects, uses and protects your personal information.", path: "/privacy" });
    return (
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="page-privacy">
            <div className="font-mono-cap text-xs text-[#c5a059] mb-3">Privacy Policy</div>
            <h1 className="font-serif-display text-4xl md:text-5xl text-slate-900 leading-tight">Privacy Policy</h1>
            <p className="text-sm text-slate-600 mt-3">Last updated: February 2026</p>
            <div className="rj-rule-gold w-12 my-8" />

            <div className="space-y-6 text-[17px] text-slate-800 leading-relaxed">
                <p>
                    Rotimi Jacobs &amp; Co., Legal Practitioners ("the firm", "we", "us") is committed to protecting the
                    privacy and confidentiality of the personal information of clients and visitors to our website.
                    This policy explains what we collect, how we use it, and the rights you have over your data.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Information we collect</h2>
                <ul className="list-disc pl-6 space-y-2">
                    <li><strong>Contact details</strong> — name, email, phone and address submitted through inquiry, registration or order forms.</li>
                    <li><strong>Order details</strong> — items purchased, delivery address and payment reference (we do not store full card numbers; payments are processed by Paystack).</li>
                    <li><strong>Account credentials</strong> — for registered users: a securely hashed password (bcrypt). We never store plaintext passwords.</li>
                    <li><strong>Usage data</strong> — anonymised page-view analytics via Google Analytics, when activated.</li>
                </ul>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">How we use it</h2>
                <ul className="list-disc pl-6 space-y-2">
                    <li>To respond to your inquiries and provide legal services.</li>
                    <li>To process publication orders and deliver hardcover or digital products.</li>
                    <li>To send transactional emails (order receipts, inquiry acknowledgements).</li>
                    <li>To comply with legal, regulatory or court obligations in Nigeria.</li>
                </ul>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Confidentiality</h2>
                <p>
                    Information shared with us in the course of seeking or receiving legal advice is protected by
                    legal professional privilege under Nigerian law and the Rules of Professional Conduct for Legal
                    Practitioners. We do not disclose client information to third parties except as authorised by
                    you or required by law.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Your rights</h2>
                <p>
                    You may request access to, correction of, or deletion of your personal data at any time by
                    contacting us at <a className="rj-link" href="mailto:rotimijacobs.law@gmail.com">rotimijacobs.law@gmail.com</a> or by writing to
                    our head office at 50 Queen Street, Yaba, Lagos.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Cookies</h2>
                <p>
                    The site uses essential cookies for session authentication and (optionally) Google Analytics to
                    understand aggregate traffic patterns. You can disable cookies in your browser settings.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Changes</h2>
                <p>
                    We may update this policy from time to time. Material changes will be flagged at the top of this
                    page with a revised effective date.
                </p>
            </div>
        </article>
    );
}
